import { useEffect } from 'react'
import personicon from '../../assets/images/personicon.svg'
import viewicon from '../../assets/images/viewicon.svg'
import chainsicon from '../../assets/images/chainsicon.svg'
import searchicon from '../../assets/images/searchicon.svg'
import growup from '../../assets/images/growup.svg'
import growdown from '../../assets/images/growdown.svg'

import { Box, List, ListItem, Paper, Typography, useMediaQuery } from '@mui/material'
import { alpha, styled, useTheme } from '@mui/material/styles'
import { gradient } from '../../theme/customColors'
import { useGetActivitiesMutation } from '../../redux/api/ihfApi'
import { useSelector } from 'react-redux'
import { type IActivity, type IUserProfile } from '../../redux/api/types'
import { PROFILE_TYPE_BUSINESS } from '../../utils/constants/profile'

const ShadowedBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  border: '2px solid #F5F6F7',
  borderRadius: '8px',
  boxShadow: `0px 2px 2px ${alpha('#F5F6F7', 0.5)}`,
  display: 'flex',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 14,
  paddingBottom: 14,
  width: '100%'
}))

const ShadowedListItem = styled(ListItem)(({ theme }) => ({
  padding: '4px 0'
}))

const shapeCircleStyles = {
  alignItems: 'center',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  p: '3px',
  position: 'relative'
}

function getActivitiesMethod () {
  const [getActivities] = useGetActivitiesMutation()
  useEffect(() => {
    getActivities({})
      .then(() => {})
      .catch(() => {})
  }, [])

  const ihfState = useSelector((state: any) => state.ihfState)
  const { activities } = ihfState
  return activities
}

const MonthlyActivity: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const activities = getActivitiesMethod()
  const editedActivities = Object.assign([], activities)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  return (
    <Paper sx={{ py: '17px', px: isMobile ? 2 : 3, boxShadow: 0, backgroundRadius: '20px', pb: '32px', height: '100%', maxHeight: '407px' }}>
      <Box sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        height: '30px',
        mb: '4px'
      }}>
        <Typography
            sx={{ color: theme.palette.grey[40] }}
            variant='caption'
        >
          Monthly Activity
        </Typography>
      </Box>
      <List sx={{ p: 0 }}>
        {editedActivities?.map((item: IActivity) => {
          const { name, count, trendPercentage } = item
          let iconBg, icon
          switch (name ? name.toUpperCase() : '') {
            case 'NEW LEADS':
              iconBg = gradient[2]
              icon = personicon
              break
            case 'PROPERTY VIEWS':
              iconBg = gradient[2]
              icon = viewicon
              break
            case 'LEAD ACTION':
              iconBg = gradient[5]
              icon = chainsicon
              break
            default:
              iconBg = gradient[3]
              icon = searchicon
              break
          }

          if (user.typeOfBusiness === PROFILE_TYPE_BUSINESS.MORTGAGE && name?.toUpperCase() === 'PROPERTY VIEWS') return <Box key={name} />

          return (
            <ShadowedListItem
            key={name}
          >
            <ShadowedBox>
              <Box
                component="div"
                sx={{
                  flexBasis: isMobile ? 34 : 42,
                  width: isMobile ? 34 : 42,
                  height: isMobile ? 34 : 42,
                  ...shapeCircleStyles
                }}
              >
                <Box sx={{
                  backgroundImage: iconBg,
                  height: '100%',
                  opacity: '30%',
                  position: 'absolute',
                  width: '100%'
                }}/>
                <Box
                  component="img"
                  src={icon}
                  sx= {{
                    width: isMobile ? 20 : 26,
                    height: isMobile ? 20 : 26
                  }}
                />
              </Box>
              <Box sx={{ mx: isMobile ? 2 : 3, width: 30, fontSize: '20px', display: 'flex', justifyContent: 'center' }}>{count}</Box>
              <Box sx={{ mx: 1, flexGrow: 1, fontSize: 14, fontWeight: 700 }}>{name}</Box>
              <Box sx={{ mx: 1, color: theme.palette.grey[80] }}>{trendPercentage > 0 ? '+' : ''}{trendPercentage != null ? (trendPercentage).toString() : '0'}%</Box>
              {
                (count === 0 || count === '-')
                  ? null
                  : <Box sx={{ ml: 1, mr: isMobile ? 1 : 2 }} component="img" src={trendPercentage > 0 ? growup : growdown}/>
              }
            </ShadowedBox>
          </ShadowedListItem>
          )
        })}
      </List>
    </Paper>
  )
}

export default MonthlyActivity
